// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-controls {
  margin-bottom: 2rem;
  padding: 1.2rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #3498db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* When inside the expanded job details */
.expanded-content .dashboard-controls {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  background-color: #f0f7ff;
  border-color: #2196f3;
}

.dashboard-controls h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: #333;
}

.expanded-content .dashboard-controls h3 {
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
}

.analysis-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.analysis-table thead {
  background-color: #eef2f5;
}

.expanded-content .analysis-table thead {
  background-color: #e3eeff;
}

.analysis-table th,
.analysis-table td {
  padding: 0.8rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e1e6ef;
}

.analysis-table th {
  font-size: 0.8rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
}

.analysis-table td {
  font-size: 0.95rem;
  color: #333;
  background-color: #fff;
}

.expanded-content .analysis-table td {
  background-color: #fafcff;
} `, "",{"version":3,"sources":["webpack://./src/components/css/DashboardControls.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".dashboard-controls {\n  margin-bottom: 2rem;\n  padding: 1.2rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #3498db;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* When inside the expanded job details */\n.expanded-content .dashboard-controls {\n  margin-top: 1rem;\n  margin-bottom: 1.5rem;\n  background-color: #f0f7ff;\n  border-color: #2196f3;\n}\n\n.dashboard-controls h3 {\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.expanded-content .dashboard-controls h3 {\n  font-size: 1.2rem;\n  margin-bottom: 0.8rem;\n}\n\n.analysis-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.analysis-table thead {\n  background-color: #eef2f5;\n}\n\n.expanded-content .analysis-table thead {\n  background-color: #e3eeff;\n}\n\n.analysis-table th,\n.analysis-table td {\n  padding: 0.8rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e1e6ef;\n}\n\n.analysis-table th {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n}\n\n.analysis-table td {\n  font-size: 0.95rem;\n  color: #333;\n  background-color: #fff;\n}\n\n.expanded-content .analysis-table td {\n  background-color: #fafcff;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
